module.exports = __webpack_public_path__ + "static/media/buttong.2ad99091.svg";